import styled, { css } from "styled-components";

interface IStyledSpan{
    truncate?: boolean;
    bold?: boolean;
}

export const StyledSpan = styled.span<IStyledSpan>`
    ${(props) => props.bold && css`
        font-weight: bold;
    `}
    
    ${(props) => props.truncate && css`
        text-overflow: ellipsis;
        flex-wrap: nowrap;
        overflow: hidden;
    `}
`;

export const LineListFields = styled.li`
    width: 100%;
    padding: 0px !important;
`;

